import script from "./FooterApp.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterApp.vue?vue&type=script&setup=true&lang=js"

import "./FooterApp.vue?vue&type=style&index=0&id=f3cbe31a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3cbe31a"]])

export default __exports__